/**
 * Browser detection helpers.
 *
 * The ServiceBox transfer (local proxy on localhost) is only validated on Chrome /
 * Chromium-based browsers. Safari and Firefox handle the localhost proxy fetch and
 * mixed content differently and can break the transfer — we advise switching to Chrome.
 */

/** True for Chrome and Chromium-based browsers (Edge, Brave, Opera, Vivaldi, Chromium). */
export function isChromiumBrowser(): boolean {
  if (typeof navigator === "undefined") return true; // SSR / unknown — don't warn
  const ua = navigator.userAgent || "";
  // Chromium engines all carry a Chrome/Chromium token (Edg/OPR are Chromium too).
  // iOS "Chrome" (CriOS) is actually WebKit, so it is intentionally excluded.
  const chromium = /Chrome\/|Chromium\//.test(ua) || /Edg\//.test(ua) || /OPR\//.test(ua);
  // Exclude iOS WebKit wrappers that also match nothing above but be safe against Firefox/Safari.
  const isFirefox = /Firefox\//.test(ua) || /FxiOS\//.test(ua);
  return chromium && !isFirefox;
}
